import { render, staticRenderFns } from "./Council.vue?vue&type=template&id=6040adaf&scoped=true"
import script from "./Council.vue?vue&type=script&lang=js"
export * from "./Council.vue?vue&type=script&lang=js"
import style0 from "./Council.vue?vue&type=style&index=0&id=6040adaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6040adaf",
  null
  
)

export default component.exports